/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { facilitiesCreate } from '../fn/facilities/facilities-create';
import { FacilitiesCreate$Params } from '../fn/facilities/facilities-create';
import { facilitiesDestroy } from '../fn/facilities/facilities-destroy';
import { FacilitiesDestroy$Params } from '../fn/facilities/facilities-destroy';
import { facilitiesList } from '../fn/facilities/facilities-list';
import { FacilitiesList$Params } from '../fn/facilities/facilities-list';
import { facilitiesPartialUpdate } from '../fn/facilities/facilities-partial-update';
import { FacilitiesPartialUpdate$Params } from '../fn/facilities/facilities-partial-update';
import { facilitiesRetrieve } from '../fn/facilities/facilities-retrieve';
import { FacilitiesRetrieve$Params } from '../fn/facilities/facilities-retrieve';
import { facilitiesUpdate } from '../fn/facilities/facilities-update';
import { FacilitiesUpdate$Params } from '../fn/facilities/facilities-update';
import { Facility } from '../models/facility';

@Injectable({ providedIn: 'root' })
export class FacilitiesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `facilitiesList()` */
  static readonly FacilitiesListPath = '/msp/api/facilities/';

  /**
   * Facilities are created/updated/deleted only by Admins, others have read-only access.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilitiesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilitiesList$Response(params?: FacilitiesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Facility>>> {
    return facilitiesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Facilities are created/updated/deleted only by Admins, others have read-only access.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilitiesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilitiesList(params?: FacilitiesList$Params, context?: HttpContext): Observable<Array<Facility>> {
    return this.facilitiesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Facility>>): Array<Facility> => r.body)
    );
  }

  /** Path part for operation `facilitiesCreate()` */
  static readonly FacilitiesCreatePath = '/msp/api/facilities/';

  /**
   * Facilities are created/updated/deleted only by Admins, others have read-only access.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilitiesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  facilitiesCreate$Response(params: FacilitiesCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<Facility>> {
    return facilitiesCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Facilities are created/updated/deleted only by Admins, others have read-only access.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilitiesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  facilitiesCreate(params: FacilitiesCreate$Params, context?: HttpContext): Observable<Facility> {
    return this.facilitiesCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Facility>): Facility => r.body)
    );
  }

  /** Path part for operation `facilitiesRetrieve()` */
  static readonly FacilitiesRetrievePath = '/msp/api/facilities/{id}/';

  /**
   * Facilities are created/updated/deleted only by Admins, others have read-only access.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilitiesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilitiesRetrieve$Response(params: FacilitiesRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<Facility>> {
    return facilitiesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Facilities are created/updated/deleted only by Admins, others have read-only access.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilitiesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilitiesRetrieve(params: FacilitiesRetrieve$Params, context?: HttpContext): Observable<Facility> {
    return this.facilitiesRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<Facility>): Facility => r.body)
    );
  }

  /** Path part for operation `facilitiesUpdate()` */
  static readonly FacilitiesUpdatePath = '/msp/api/facilities/{id}/';

  /**
   * Facilities are created/updated/deleted only by Admins, others have read-only access.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilitiesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  facilitiesUpdate$Response(params: FacilitiesUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Facility>> {
    return facilitiesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Facilities are created/updated/deleted only by Admins, others have read-only access.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilitiesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  facilitiesUpdate(params: FacilitiesUpdate$Params, context?: HttpContext): Observable<Facility> {
    return this.facilitiesUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Facility>): Facility => r.body)
    );
  }

  /** Path part for operation `facilitiesDestroy()` */
  static readonly FacilitiesDestroyPath = '/msp/api/facilities/{id}/';

  /**
   * Facilities are created/updated/deleted only by Admins, others have read-only access.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilitiesDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilitiesDestroy$Response(params: FacilitiesDestroy$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return facilitiesDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Facilities are created/updated/deleted only by Admins, others have read-only access.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilitiesDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilitiesDestroy(params: FacilitiesDestroy$Params, context?: HttpContext): Observable<void> {
    return this.facilitiesDestroy$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `facilitiesPartialUpdate()` */
  static readonly FacilitiesPartialUpdatePath = '/msp/api/facilities/{id}/';

  /**
   * Facilities are created/updated/deleted only by Admins, others have read-only access.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilitiesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  facilitiesPartialUpdate$Response(params: FacilitiesPartialUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Facility>> {
    return facilitiesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Facilities are created/updated/deleted only by Admins, others have read-only access.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilitiesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  facilitiesPartialUpdate(params: FacilitiesPartialUpdate$Params, context?: HttpContext): Observable<Facility> {
    return this.facilitiesPartialUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Facility>): Facility => r.body)
    );
  }

}
